import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute, useAuth } from './lib/auth.jsx'
import LandingPage from './pages/LandingPage.jsx'
import LoginPage from './pages/LoginPage.jsx'
import SignupPage from './pages/SignupPage.jsx'
import OnboardingPage from './pages/OnboardingPage.jsx'
import HealthDashboard from './pages/HealthDashboard.jsx'
import PWAUpdatePrompt from './components/UI/PWAUpdatePrompt.jsx'
import InstallPrompt from './components/UI/InstallPrompt.jsx'

export default function App() {
  const { session, loading } = useAuth()
  return (
    <>
      <Routes>
        <Route path="/" element={
          loading ? <Splash /> : (session ? <Navigate to="/health" replace /> : <LandingPage />)
        } />
        <Route path="/login"  element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/onboarding" element={
          <ProtectedRoute><OnboardingPage /></ProtectedRoute>
        } />
        <Route path="/health" element={
          <ProtectedRoute><HealthDashboard /></ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <PWAUpdatePrompt />
      <InstallPrompt />
    </>
  )
}

function Splash() {
  return (
    <div className="min-h-screen grid place-items-center text-arise-muted font-display tracking-widest">
      ◆ ARISE ◆
    </div>
  )
}
